'use client';

import PageTransition from '@components/PageTransition';

type Props = {
  children: React.ReactNode;
};

export default function PageWrapper({ children }: Props) {
  return <PageTransition>{children}</PageTransition>;
}
